export default "__VITE_ASSET__DPUDTf8P__"